import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export interface DeleteMessageMutation {
  deleteMessage: { id: string };
}

export interface DeleteMessageMutationVariables {
  input: { id: string };
}

export const DELETE_MESSAGE: TypedDocumentNode<
  DeleteMessageMutation,
  DeleteMessageMutationVariables
> = gql`
  mutation DeleteMessage($input: DeleteMessageInput!) {
    deleteMessage(input: $input) {
      id
    }
  }
`;
